/* eslint-disable max-len */
import React from 'react';

export const CustomizedCheckCircleOutlineIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none'>
    <path
      fill='#4CAF50'
      fillRule='evenodd'
      d='M16 29.333c7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.333-13.333-13.333C8.636 2.667 2.667 8.637 2.667 16c0 7.364 5.97 13.333 13.333 13.333Zm8.252-16.17a1 1 0 0 0-1.414-1.415L14 20.586l-4.953-4.953a1 1 0 0 0-1.414 1.414l5.189 5.189c.65.65 1.706.65 2.357 0l9.073-9.074Z'
      clipRule='evenodd'
    />
  </svg>
);
